// extracted by mini-css-extract-plugin
module.exports = {"addBrancheHolder":"branches-settings_addBrancheHolder__q3cOl"};